import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg width="29.35" height="32.221" viewBox="0 0 29.35 32.221" {...props}>
      <defs>
        <style>
          {`.prefix__prefix__cls-1menuresearchicon{fill:none;stroke:${props.color};stroke-linecap:round;stroke-linejoin:round}`}
        </style>
      </defs>
      <g
        id="Group_3348"
        data-name="Group 3348"
        transform="translate(-1012.171 -266.829)"
      >
        <line
          id="Line_1264"
          data-name="Line 1264"
          x1="6.125"
          transform="translate(1026.798 295.422)"
          className="prefix__prefix__cls-1menuresearchicon"
          stroke-miterlimit="10"
          stroke-width="1.6"
        />
        <line
          id="Line_1266"
          data-name="Line 1266"
          x1="6.125"
          transform="translate(1026.798 293.037)"
          className="prefix__prefix__cls-1menuresearchicon"
          stroke-miterlimit="10"
          stroke-width="1.6"
        />
        <rect
          id="Rectangle_446"
          data-name="Rectangle 446"
          width="2.145"
          height="12.917"
          transform="translate(1040.721 292.723) rotate(180)"
          className="prefix__prefix__cls-1menuresearchicon"
          stroke-miterlimit="10"
          stroke-width="1.6"
        />
        <path
          id="Rectangle_447"
          data-name="Rectangle 447"
          d="M1.072,0h0A1.072,1.072,0,0,1,2.145,1.072V3.718a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1.072A1.072,1.072,0,0,1,1.072,0Z"
          transform="translate(1040.721 296.441) rotate(180)"
          className="prefix__prefix__cls-1menuresearchicon"
          stroke-miterlimit="10"
          stroke-width="1.6"
        />
        <line
          id="Line_1265"
          data-name="Line 1265"
          y2="2.162"
          transform="translate(1039.649 296.441)"
          className="prefix__prefix__cls-1menuresearchicon"
          stroke-miterlimit="10"
          stroke-width="1.6"
        />
        <path
          id="Rectangle_448"
          data-name="Rectangle 448"
          d="M0,0H2.145a0,0,0,0,1,0,0V1.072A1.072,1.072,0,0,1,1.072,2.145h0A1.072,1.072,0,0,1,0,1.072V0A0,0,0,0,1,0,0Z"
          transform="translate(1040.721 279.806) rotate(180)"
          className="prefix__prefix__cls-1menuresearchicon"
          stroke-miterlimit="10"
          stroke-width="1.6"
        />
        <g
          id="Group_3347"
          data-name="Group 3347"
          transform="translate(1015.51 270.24)"
        >
          <g id="Group_3346" data-name="Group 3346" transform="translate(0 0)">
            <path
              id="Path_4284"
              data-name="Path 4284"
              d="M1040.861,291.926a19.046,19.046,0,0,1-.465-4.272c0-5.148,1.877-9.322,4.193-9.322s4.193,4.174,4.193,9.322-1.877,9.323-4.193,9.323a2.008,2.008,0,0,1-.775-.159"
              transform="translate(-1036.246 -278.331)"
              className="prefix__prefix__cls-1menuresearchicon"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.6"
            />
            <path
              id="Path_4285"
              data-name="Path 4285"
              d="M1075.341,292.948a5.621,5.621,0,0,0-4.2-.443"
              transform="translate(-1059.494 -288.911)"
              className="prefix__prefix__cls-1menuresearchicon"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.6"
            />
            <path
              id="Path_4286"
              data-name="Path 4286"
              d="M1026.181,322.442a2.973,2.973,0,0,1-2.529-1.233c-.672-1.164-.052-2.9,1.458-4.661"
              transform="translate(-1023.382 -307.226)"
              className="prefix__prefix__cls-1menuresearchicon"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.6"
            />
            <g
              id="Group_3343"
              data-name="Group 3343"
              transform="translate(14.899 5.745)"
            >
              <circle
                id="Ellipse_283"
                data-name="Ellipse 283"
                cx="1.356"
                cy="1.356"
                r="1.356"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
                className="prefix__prefix__cls-1menuresearchicon"
              />
            </g>
            <g
              id="Group_3344"
              data-name="Group 3344"
              transform="translate(1.025 2.136)"
            >
              <path
                id="Path_4287"
                data-name="Path 4287"
                d="M1030.3,288.444a1.356,1.356,0,1,0-1.356,1.356A1.356,1.356,0,0,0,1030.3,288.444Z"
                transform="translate(-1027.585 -287.088)"
                className="prefix__prefix__cls-1menuresearchicon"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.6"
              />
            </g>
            <g
              id="Group_3345"
              data-name="Group 3345"
              transform="translate(4.15 14.965)"
            >
              <path
                id="Path_4288"
                data-name="Path 4288"
                d="M1043.108,341.035a1.356,1.356,0,1,0-1.356,1.356A1.356,1.356,0,0,0,1043.108,341.035Z"
                transform="translate(-1040.396 -339.679)"
                className="prefix__prefix__cls-1menuresearchicon"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.6"
              />
            </g>
            <path
              id="Path_4289"
              data-name="Path 4289"
              d="M1027.666,307.1c-2.745-2.042-4.418-4.435-4.276-6.147"
              transform="translate(-1023.382 -295.438)"
              className="prefix__prefix__cls-1menuresearchicon"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="1.6"
            />
            <path
              id="Path_4290"
              data-name="Path 4290"
              d="M1062.719,306.941c3.243,2.412,4.99,5.315,4.014,7-.672,1.164-2.488,1.5-4.766,1.068a15.507,15.507,0,0,1-2.961-.9"
              transform="translate(-1050.317 -299.962)"
              className="prefix__prefix__cls-1menuresearchicon"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="1.6"
            />
          </g>
          <path
            id="Path_4291"
            data-name="Path 4291"
            d="M1044.03,293.046a13.16,13.16,0,0,1,3.483,1.219"
            transform="translate(-1038.993 -289.456)"
            className="prefix__prefix__cls-1menuresearchicon"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.6"
          />
        </g>
        <path
          id="Path_4292"
          data-name="Path 4292"
          d="M1016.008,295.213v.9a2.135,2.135,0,0,0,2.135,2.135h17.11V267.629h-22.283v25.449a2.135,2.135,0,0,0,2.135,2.135Z"
          className="prefix__prefix__cls-1menuresearchicon"
          stroke-miterlimit="10"
          stroke-width="1.6"
        />
        <path
          id="Path_4293"
          data-name="Path 4293"
          d="M1104.318,275.07h2.051v6.692"
          transform="translate(-69.065 -5.626)"
          className="prefix__prefix__cls-1menuresearchicon"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="1.6"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
